import React, { memo, useEffect, useState } from 'react';
import classes from '../Box/Box.module.css';
import { Box, Paper, Select, SimpleGrid, Space, Text, TextInput, Title } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { IoAddOutline, IoTrashOutline } from "react-icons/io5";
import { baseUrl } from '../../../../../../Constants/constant';
import useFetch from '../../../../../../Customhooks/useFetch';


interface FormField {
    id_comp: number;
    id: number | null;
    no_of_box: string;
    co2_embodiment: string;
    weight: string;
    pallet_id: string | null;
}

interface FactoryCharacteristicsProps {
    onFieldsChange: (fields: FormField[]) => void;
    onValidationChange: (isValid: boolean) => void;
    showErrors: boolean;
    initialFields?: FormField[];
}

const PalletsPackaging: React.FC<FactoryCharacteristicsProps> = ({
    onFieldsChange,
    onValidationChange,
    showErrors,
    initialFields,

}) => {
    const [errors, setErrors] = useState<Record<string, string>>({});
    const [boxdata, setBoxData] = useState<any>();
    const [boxDetails, setBoxDetails] = useState<Record<string, any>>({});
    const [fields, setFields] = useState<FormField[]>([{
        id_comp: 1,
        // country: null,
        id: null,
        no_of_box: "",
        co2_embodiment: "",
        weight: "",
        pallet_id: null,
    }]);

    const { id } = useParams();
    const token = localStorage.getItem("token");

    const fetchConfig = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            token: token,
        },
    };
    const { data: getDataBoxes, fetchData: fetchboxes, } = useFetch(fetchConfig);

    useEffect(() => {
        fetchboxes(`${baseUrl}admin/pallets`)
    }, []);
    useEffect(() => {
        if (getDataBoxes?.data?.rows) {
            // Create box options for Select
            const boxesOptions = getDataBoxes?.data?.rows?.map((el: any) => ({
                value: el.id.toString(),
                label: el.pallet_name,
            }));
            setBoxData(boxesOptions);

            // Create a mapping of box details for easy lookup
            const boxDetailsMap = getDataBoxes.data.rows.reduce((acc: Record<string, any>, el: any) => {
                acc[el.id.toString()] = el;
                return acc;
            }, {});
            setBoxDetails(boxDetailsMap);
        }
    }, [getDataBoxes])

    useEffect(() => {
        onFieldsChange(fields);
        const isValid = validateFields();
        onValidationChange(isValid);
    }, [fields]);



    useEffect(() => {
        if (initialFields && initialFields.length > 0) {
            const updatedFields = initialFields.map(field => ({
                ...field,
                no_of_box: field.no_of_box?.toString() || "",
                co2_embodiment: field.co2_embodiment?.toString() || "",
                weight: field.weight?.toString() || "",
                pallet_id: field.pallet_id?.toString() || null,
            }));
            setFields(updatedFields);
        }
    }, [initialFields]);




    const validateFields = () => {
        const newErrors: Record<string, string> = {};
        let isValid = true;

        fields.forEach((field, index) => {
            if (!field.pallet_id) {
                newErrors[`pallet_id${index}`] = "Process name is required";
                isValid = false;
            }


            if (!field.no_of_box) {
                newErrors[`no_of_box${index}`] = "No. of product is required";
                isValid = false;
            }
        });

        setErrors(newErrors);
        onValidationChange(isValid);
        return isValid;
    };


    const handleChange = (index: number, field: keyof FormField, value: string | null) => {
        setFields(prev => {
            const newFields = [...prev];

            // Update the current field value
            newFields[index] = {
                ...newFields[index],
                [field]: value
            };

            if (field === 'pallet_id' && value) {
                const selectedBoxDetail = boxDetails[value];
                if (selectedBoxDetail) {
                    newFields[index].co2_embodiment = selectedBoxDetail.co2_embodiment || "";
                }
            }

            return newFields;
        });
    };
    useEffect(() => {
        onFieldsChange(fields);
        if (showErrors) {
            validateFields();
        }
    }, [fields, showErrors]);

    const addComponent = () => {
        // Reset all errors
        setErrors({});
        // Reset show errors state in parent component if needed
        if (onValidationChange) {
            onValidationChange(true);
        }

        // Add new component
        setFields(prev => [...prev, {
            id_comp: prev.length + 1,
            id: null,
            no_of_box: "",
            co2_embodiment: "",
            weight: "",
            pallet_id: null,
        }]);
    };
    const handledeletecomponent = (id_comp: any) => {
        setFields(prev => prev.filter(field => field.id_comp !== id_comp));
    };

    return (
        <div>
            <Title order={4}>Pallets</Title>
            <Space h="lg" />
            {fields.map((field, index) => (
                <Paper className={classes.productdiv} key={field.id_comp} shadow="xs" p="xs" radius="md" mb={10}>
                    <Space />
                    {fields.length > 1 && (
                        <Box className={classes.delete_box}>
                            <IoTrashOutline
                                fill="red"
                                size={20}
                                onClick={() => handledeletecomponent(field.id_comp)}
                            />
                        </Box>
                    )}

                    <Box ml={5}>
                        <SimpleGrid cols={2}>
                            <Select
                                label="Pallets"
                                withAsterisk
                                placeholder="Select Pallet"
                                data={boxdata}
                                variant="filled"
                                searchable
                                radius={6}
                                maxDropdownHeight={200}
                                value={field.pallet_id}
                                onChange={(value) => handleChange(index, "pallet_id", value)}
                                error={showErrors ? errors[`pallet_id${index}`] : null}
                            />
                            <TextInput
                                label="No of Box"
                                withAsterisk
                                placeholder="Enter An Amount"
                                variant="filled"
                                value={field.no_of_box}
                                onChange={(e) => handleChange(index, "no_of_box", e.target.value)}
                                error={showErrors ? errors[`no_of_box${index}`] : null}
                            />
                            <TextInput
                                label="CO₂ Embodiment per km"
                                withAsterisk
                                placeholder="0.000"
                                variant="filled"
                                value={field.co2_embodiment}
                                onChange={(e) => handleChange(index, "co2_embodiment", e.target.value)}
                                error={showErrors ? errors[`co2_embodiment${index}`] : null}
                                display={'none'}
                            />
                            {/* <TextInput
                                label="Weight"
                                withAsterisk
                                placeholder="0.000"
                                variant="filled"
                                value={field.weight}
                                onChange={(e) => handleChange(index, "weight", e.target.value)}
                                error={showErrors ? errors[`weight${index}`] : null}
                            /> */}
                            <TextInput
                                value={field.id_comp}
                                onChange={(e) => handleChange(index, "id", e.target.value)}
                                style={{ display: 'none' }}
                            />
                        </SimpleGrid>
                    </Box>
                    <Space h="sm" />
                </Paper>
            ))}
            {/* <Box className={classes.addmoreleg}>
                <span style={{ display: 'flex' }}><IoAddOutline size={18} /></span>
                <Text
                    variant="default"
                    onClick={addComponent}
                    ta="right"
                    pl={4}
                >
                    Add Pallets
                </Text>
            </Box> */}
        </div>
    );
};

export default memo(PalletsPackaging);